const fs = require('fs');
const path = require('path');
const { spawnSync } = require('child_process');
const yaml = require('js-yaml');

let globalCredentials;

/**
 * Attempts to load a JSON encoded string from the local environment.
 * @param {String} key - name of the env variable.
 * @param {*} fallback - the default value to return if the setting is missing
 * @param {Boolean} options.strict - If true, will throw an error when key not in config. If false,
 * will return the fallback on error.
 */
function get(key, fallback = null, { strict = false }  = {} ) {
  const envVar = key.toUpperCase();
  if (!(envVar in process.env)) {
    if (strict) {
      throw new Error(`key ${key} as ${envVar} not found in environment`);
    }
    return fallback
  }

  try {
    return JSON.parse(process.env[envVar]);
  } catch (err) {
    return process.env[envVar];
  }
}

const getGlobalServiceCredentials = () => {
  const script = path.resolve(
    process.cwd(), '../../../.rig/hooks/prebuild_setup_global_service_credentials'
  );
  const credentialsPath = '/global-service-credentials.yml';
  const credentialsLocalPath = path.resolve(process.cwd(), './global-service-credentials.yml');

  /**
   * To prevent breaking functonality that is dependent on service credentials when locally
   * developing, the following condition will check if the module is running in development and will
   * create a global-service-credentials.yml file in the current working directory if one doesnt
   * already exist.
   *
   * 1) The `prebuild_setup_global_service_credentials` rig hook script file should exist if module
   *    is running on local machine.
   * 2) Run `prebuild_setup_global_service_credentials` as a synchronouse subprocess to create
   *    `./global-service-credentials.yml`
   */
  const is_dev = fs.existsSync(script);

  if (is_dev && !fs.existsSync(credentialsLocalPath)) {
    spawnSync(script);
  }

  return yaml.load(fs.readFileSync(is_dev ? credentialsLocalPath : credentialsPath, 'utf-8'));
};

/**
 * Returns the specified value from global-service-credentials.yml. You can override these by
 * setting environment variables with the same name because it reads from environment variables
 * first then fall back to the global credentials provided by rig.
 * @param {String} key - the key to read from the global credentials
 * @returns {*} - the config value
 */
const getGlobal = (key) => {
  if (!globalCredentials) {
    globalCredentials = getGlobalServiceCredentials();
  }

  const KEY = key.toUpperCase();
  const value = get(KEY, globalCredentials[key.toLowerCase()]);

  if (!value) {
    throw new Error(`key ${key} as ${KEY} not found in global config`);
  }

  return value;
};

module.exports = {
  get,
  getGlobal,
};
